import React from 'react'

const Banner = (props) => (
    <section id="banner" className="major">
        <div className="inner">
            <header className="major">
                <h1 >Digital Future | Engineering Craftsmanship</h1>
            </header>
            <div className="content">
                <p>As a part of the NEUMAN & ESSER GROUP we build upon primary source knowledge and excellent engineering skills for developing state-of-the-art industrial IoT-solutions.</p>
                <ul className="actions">
                    <li><a href="https://portal.neaxplore.com" className="button next scrolly">Try it out</a></li>
                </ul>
            </div>
        </div>
    </section>
)

export default Banner
